import React from 'react';
import { useVerseArtUrl } from '../../hooks/useVerseArtUrl';

const ChapterArtBackdrop = ({
  chapterNumber,
  slokaNumber,
  children,
  className = '',
  variant = 'dark'
}) => {
  const artUrl = useVerseArtUrl(chapterNumber, slokaNumber);

  if (!artUrl) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div className={`chapter-art-backdrop chapter-art-backdrop--${variant} ${className}`}>
      <div
        className="chapter-art-backdrop-image"
        style={{ backgroundImage: `url(${artUrl})` }}
        aria-hidden="true"
      />
      <div className="chapter-art-backdrop-overlay" aria-hidden="true" />
      <div className="chapter-art-backdrop-content">{children}</div>
    </div>
  );
};

export default ChapterArtBackdrop;
